import { render, staticRenderFns } from "./registrar_usuario.vue?vue&type=template&id=d6ccb8be&"
import script from "./registrar_usuario.vue?vue&type=script&lang=js&"
export * from "./registrar_usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports